import { render } from "./IdentityGraphContainer.vue?vue&type=template&id=3c937101"
import script from "./IdentityGraphContainer.vue?vue&type=script&lang=js"
export * from "./IdentityGraphContainer.vue?vue&type=script&lang=js"

import "./IdentityGraphContainer.vue?vue&type=style&index=0&id=3c937101&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__